import React from "react";
import { FormGroup } from "react-bootstrap";

type InputToggleProps = {
  disabled?: boolean;
  className?: string;
  name: string;
  onBlur: () => void;
  onChange: () => void;
  value: boolean;
};

export const InputToggle = ({
  className,
  disabled,
  name,
  onBlur,
  onChange,
  value,
}: InputToggleProps) => {
  return (
    <div className={`SwitchGroup ${className}`}>
      <FormGroup>
        <div>
          <label className="switch">
            <input
              name={name}
              disabled={disabled}
              type="checkbox"
              checked={value}
              onChange={onChange}
              onBlur={onBlur}
            />
            <em />
          </label>
        </div>
      </FormGroup>
    </div>
  );
};
